import styled from 'styled-components'

export const RegisterBarrierModalContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: min(90vh, 900px);
  width: 100%;
  overflow: hidden;
`

export const RegisterBarrierModalBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 0 20px;
`

export const RegisterBarrierModalFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px 20px;
  background-color: white;
  border-top: 1px solid #eaecf0;
`

export const RegisterBarrierImageDrawContainer = styled.div`
  margin-top: 10px;
  min-height: 300px;

  @media (max-height: 800px) {
    min-height: 200px;
  }

  @media (max-height: 600px) {
    min-height: 160px;
  }
`
